var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/verify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.08 14.3202L27.2667 12.2136C26.92 11.8136 26.64 11.0669 26.64 10.5336V8.26691C26.64 6.85357 25.48 5.69357 24.0667 5.69357H21.8C21.28 5.69357 20.52 5.41357 20.12 5.06691L18.0134 3.25357C17.0934 2.46691 15.5867 2.46691 14.6534 3.25357L12.56 5.08024C12.16 5.41357 11.4 5.69357 10.88 5.69357H8.57338C7.16005 5.69357 6.00005 6.85357 6.00005 8.26691V10.5469C6.00005 11.0669 5.72005 11.8136 5.38671 12.2136L3.58671 14.3336C2.81338 15.2536 2.81338 16.7469 3.58671 17.6669L5.38671 19.7869C5.72005 20.1869 6.00005 20.9336 6.00005 21.4536V23.7336C6.00005 25.1469 7.16005 26.3069 8.57338 26.3069H10.88C11.4 26.3069 12.16 26.5869 12.56 26.9336L14.6667 28.7469C15.5867 29.5336 17.0934 29.5336 18.0267 28.7469L20.1334 26.9336C20.5334 26.5869 21.28 26.3069 21.8134 26.3069H24.08C25.4934 26.3069 26.6534 25.1469 26.6534 23.7336V21.4669C26.6534 20.9469 26.9334 20.1869 27.28 19.7869L29.0934 17.6802C29.8667 16.7602 29.8667 15.2402 29.08 14.3202ZM21.88 13.4802L15.44 19.9202C15.2534 20.1069 15 20.2136 14.7334 20.2136C14.4667 20.2136 14.2134 20.1069 14.0267 19.9202L10.8 16.6936C10.4134 16.3069 10.4134 15.6669 10.8 15.2802C11.1867 14.8936 11.8267 14.8936 12.2134 15.2802L14.7334 17.8002L20.4667 12.0669C20.8534 11.6802 21.4934 11.6802 21.88 12.0669C22.2667 12.4536 22.2667 13.0936 21.88 13.4802Z",
    fill: "#292D32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.f13cf5234bcc648c89f849b3136fa139.svg";
export { ForwardRef as ReactComponent };